import { createFileRoute } from '@tanstack/react-router'

import { useGetClientMarket, useGetFixSession } from '@/gen/publicApi'

import { UnexpectedDataStateError } from '@/containers/unexpectedDataStateError'

import Content from '@/components/content'

import { useSetBreadcrumbs } from '@/state/breadcrumbs.tsx'

import MarketHeading from '../../-components/marketHeading'

import FixSessionDetails from './-components/details'
import FixSesssionMessageTable from './-components/messageTable'

export const Route = createFileRoute('/_authed/$client_code/markets/$market_code/connections/fix/$session_id/')({
    component: MarketConnectionsComponent,
})

function MarketConnectionsComponent() {
    const { client_code, market_code, session_id } = Route.useParams()

    const market = useGetClientMarket(client_code, market_code, { query: { suspense: true } })
    const { data: sessionData } = useGetFixSession(client_code, session_id, { query: { suspense: true } })

    useSetBreadcrumbs([
        {
            to: '/$client_code/markets',
            text: 'Markets',
            params: {
                client_code,
            },
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code',
            params: {
                market_code,
                client_code,
            },
            text: market.data?.name || '--',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/connections',
            params: {
                market_code,
                client_code,
            },
            text: 'Connections',
        },
        'seperator',
        {
            to: '/$client_code/markets/$market_code/connections/fix/$session_id',
            params: {
                market_code,
                client_code,
                session_id,
            },
            text: `${sessionData?.senderCompId} -> ${sessionData?.targetCompId} (FIX)`,
        },
    ])

    if (!market.data || !sessionData) {
        return <UnexpectedDataStateError />
    }

    return (
        <>
            <MarketHeading market={market.data} />
            <Content>
                <FixSessionDetails clientCode={client_code} sessionId={session_id} />

                <h2 className="mb-4">Messages</h2>
                <FixSesssionMessageTable clientCode={client_code} sessionId={session_id} />
            </Content>
        </>
    )
}
